// Redirect legacy or slashless paths before S3/CloudFront can leak the deploy commit hash.
const PATH_REDIRECTS = {
  '/how-it-works': '/features/',
  '/how-it-works/': '/features/'
}

const { pathname, search, hash } = window.location
const pathRedirect = PATH_REDIRECTS[pathname]

if (pathRedirect) {
  window.location.replace(`${pathRedirect}${search}${hash}`)
} else {
  const segment = pathname.split('/').pop() || ''

  if (pathname !== '/' && !pathname.endsWith('/') && !segment.includes('.')) {
    window.location.replace(`${pathname}/${search}${hash}`)
  }
}
